// extracted by mini-css-extract-plugin
export default {"textContainer":"Privacy_textContainer__ZcK-b","privacyContainer":"Privacy_privacyContainer__Ot2q8"};